import React from 'react';
import { IoCheckmarkDoneSharp } from 'react-icons/io5';
import AnimatedSection from '../ui/AnimatedSection';
import AnimatedCard from '../ui/AnimatedCard';

const About = () => {
  return (
    <section id="about" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-8">
            <h2 className="text-sm font-semibold text-blue-400 uppercase tracking-wider mb-2">About</h2>
            <p className="text-3xl md:text-4xl font-bold text-white">About Us</p>
          </div>
        </AnimatedSection>
        
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <AnimatedCard index={0}>
            <div className="dark-card rounded-xl p-8 relative z-10">
              <h3 className="text-2xl font-bold mb-4 text-white">Your Technology Partner for Success</h3>
              <p className="mb-6 text-gray-300 leading-relaxed">
                We deliver comprehensive IT solutions that help businesses reduce costs, improve efficiency, and accelerate growth. Our expertise spans custom web applications, mobile solutions, and quality assurance services.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <IoCheckmarkDoneSharp className="text-blue-400 mr-3 mt-1 flex-shrink-0 text-xl" />
                  <span className="text-gray-300">Streamlined digital transformation that reduces operational costs</span>
                </li>
                <li className="flex items-start">
                  <IoCheckmarkDoneSharp className="text-blue-400 mr-3 mt-1 flex-shrink-0 text-xl" />
                  <span className="text-gray-300">Comprehensive software testing that ensures quality and reliability</span>
                </li>
                <li className="flex items-start">
                  <IoCheckmarkDoneSharp className="text-blue-400 mr-3 mt-1 flex-shrink-0 text-xl" />
                  <span className="text-gray-300">SEO optimization that increases your online visibility and leads</span>
                </li>
              </ul>
            </div>
          </AnimatedCard>
          
          <AnimatedCard index={1}>
            <div className="dark-card rounded-xl p-8 relative z-10">
              <h3 className="text-2xl font-bold mb-4 text-white">Expert Training Programs</h3>
              <p className="mb-6 text-gray-300 leading-relaxed">
                Build your team's capabilities with hands-on training from industry experts with 15+ years of experience. Our programs equip your staff with practical skills that deliver immediate business value.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <IoCheckmarkDoneSharp className="text-purple-400 mr-3 mt-1 flex-shrink-0 text-xl" />
                  <span className="text-gray-300">Manual and automated software testing methodologies</span>
                </li>
                <li className="flex items-start">
                  <IoCheckmarkDoneSharp className="text-purple-400 mr-3 mt-1 flex-shrink-0 text-xl" />
                  <span className="text-gray-300">Full-stack web development with ASP.NET, C#, and SQL Server</span>
                </li>
                <li className="flex items-start">
                  <IoCheckmarkDoneSharp className="text-purple-400 mr-3 mt-1 flex-shrink-0 text-xl" />
                  <span className="text-gray-300">Modern frameworks: React, Angular, and responsive design</span>
                </li>
              </ul>
            </div>
          </AnimatedCard>
        </div>
        
        <AnimatedSection delay={0.4}>
          <div className="mt-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl shadow-xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Why Choose Ramwin Technology</h3>
            <p className="text-lg leading-relaxed text-blue-50">
              We combine deep technical expertise with a client-first approach. Our solutions are designed to solve real business challenges, improve customer satisfaction, and drive measurable ROI. Partner with us to transform your technology infrastructure and achieve sustainable competitive advantage.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default About;